import { cn } from '@/utils/styles/cn'

interface IFooterItemProps {
    label: string | React.ReactNode
    href?: string
    onClick?: () => void
    isCookieTrigger?: boolean
    className?: string
}

export const FooterItem = ({
    label,
    href,
    onClick,
    isCookieTrigger,
    className,
}: IFooterItemProps) => {
    if (!href && !isCookieTrigger) {
        return (
            <div
                onClick={onClick}
                className={cn(
                    'text-fg-secondary hover:text-fg-primary text-p-md cursor-pointer',
                    className
                )}
            >
                {label}
            </div>
        )
    }
    return (
        <a
            href={href}
            target={href?.startsWith('http') ? '_blank' : undefined}
            onClick={onClick}
            // The iubenda script stamps data attributes onto its trigger link
            // before hydration, which is a false-positive hydration mismatch
            suppressHydrationWarning={isCookieTrigger}
            className={cn(
                isCookieTrigger && 'iubenda-cs-preferences-link text-reset',
                'text-fg-secondary hover:text-fg-primary text-p-md',
                className
            )}
        >
            {label}
        </a>
    )
}
